var exports = {
  "C": "x31de4314--845964--btn-spacer",
};

module.exports = exports;
